const processPdfOcr = async ({ api, token, documentId, documentSubCategory, file }) => {
	try {
		const formData = new FormData();

		formData.append("file", file, "document.pdf");
		formData.append("document_id", documentId);
		formData.append("document_sub_category", documentSubCategory);

		const response = await fetch(api, {
			method: "POST",
			headers: {
				Accept: "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		});

		const data = await response.json();

		return data;
	} catch (error) {
		return error;
	}
};

export default processPdfOcr;
